export const CUSTOMER_TRANSLATIONS: Record<string, string> = {
  '(UTC+2) Калининград': '(UTC+2) Kaliningrad',
  '(UTC+3) Москва': '(UTC+3) Moscow',
  '(UTC+3) Москва, Санкт-Петербург': '(UTC+3) Moscow, Saint Petersburg',
  '(UTC+5) Екатеринбург': '(UTC+5) Yekaterinburg',
  '← Выберите чат': '← Select a chat',
  '+ Добавить заявку': '+ Add request',
  '⚠ Подавайте только если реально есть проблема. Модератор LOVO разберёт за 24 часа. До разбора чат остаётся открыт.': '⚠ Open a dispute only when there is a genuine problem. A LOVO moderator will review it within 24 hours. The chat remains open during the review.',
  '✓ Верификация': '✓ Verification',
  '✓ Оплата отмечена': '✓ Payment marked',
  '✓ Питомец у вас? Подтвердите': '✓ Is your pet with you? Please confirm',
  '✓ Я получил питомца': '✓ I received my pet',
  '⭐ Рейтинги и отзывы': '⭐ Ratings and reviews',
  '👁 Это превью — так ваш профиль выглядит для перевозчика. Личные данные скрыты до принятия отклика.': '👁 This preview shows how carriers see your profile. Personal details remain hidden until you accept an offer.',
  '👍 Точно да': '👍 Definitely',
  '👎 Нет': '👎 No',
  '💬 Чат с перевозчиком': '💬 Carrier chat',
  '💸 Бесплатно для меня': '💸 Free for me',
  '📷 Фото-отчёты в пути': '📷 Journey photo reports',
  '🔍 Удобный поиск': '🔍 Easy search',
  '🔒 Пароль': '🔒 Password',
  '🔔 Уведомления': '🔔 Notifications',
  '🤔 Возможно': '🤔 Maybe',
  '₸ Казахстанский тенге': '₸ Kazakhstani tenge',
  '₽ Российский рубль': '₽ Russian rouble',
  '€ Евро': '€ Euro',
  'Br Белорусский рубль': 'Br Belarusian rouble',
  'автоматически': 'automatically',
  'Безопасность': 'Security',
  'Бережность к питомцу': 'Care for the pet',
  'В этой категории пока нет заявок': 'There are no requests in this category yet',
  'Валюта отображения': 'Display currency',
  'Ваша оценка перевозчика': 'Your carrier rating',
  'Ваш ответ': 'Your answer',
  'Ваш ответ (увидят все перевозчики)…': 'Your answer (visible to all carriers)…',
  'Ваши отзывы помогают нам становиться лучше · команда LOVO лично читает каждый': 'Your feedback helps us improve · the LOVO team reads every review',
  'Вернуться к откликам': 'Back to offers',
  'Вложение': 'Attachment',
  'Вложение в чате': 'Chat attachment',
  'Вопросов от перевозчиков пока нет': 'There are no carrier questions yet',
  'Вопросы к заявке': 'Questions about the request',
  'Все ваши заявки на перевозку': 'All your transport requests',
  'Все события по вашим заявкам': 'All activity for your requests',
  'Все фото, сделанные перевозчиком на маршруте, прикрепляются к отзыву.': 'All photos taken by the carrier during the trip are attached to the review.',
  'Все фото, сделанные перевозчиком на этом маршруте, прикрепляются к отзыву и попадают в его публичное портфолио.': 'All photos taken by the carrier on this route are attached to the review and added to their public portfolio.',
  'Всего заявок': 'Total requests',
  'вчера': 'yesterday',
  'Выбрать': 'Select',
  'Выполнено': 'Completed',
  'Город': 'City',
  'Готовы рекомендовать LOVO друзьям и знакомым?': 'Would you recommend LOVO to friends and family?',
  'Дата выезда': 'Departure date',
  'Дата доставки': 'Delivery date',
  'Для смены — обратитесь в поддержку': 'Contact support to change this',
  'Документы готовы': 'Documents ready',
  'Доставлена': 'Delivered',
  'Другое животное': 'Other animal',
  'завершённых перевозок': 'completed transports',
  'Завершённых перевозок': 'Completed transports',
  'Загрузка…': 'Loading…',
  'Заказчик отметил оплату': 'Customer marked the payment as complete',
  'Запланирована': 'Scheduled',
  'Запрещены': 'Disabled',
  'Заявка принята': 'Request accepted',
  'Здесь редактируете личные данные. Перевозчики увидят только имя и оценку — телефон, адрес и email скрыты.': 'Edit your personal details here. Carriers see only your name and rating; your phone, address and email remain hidden.',
  'Поддержка': 'Support',
  'Ваши обращения и ответы операторов LOVO': 'Your support requests and responses from LOVO operators',
  'Новое обращение': 'New request',
  'Обращения в поддержку': 'Support requests',
  'Тема вопроса': 'Topic',
  'Заголовок': 'Subject',
  'Коротко опишите вопрос': 'Briefly describe the issue',
  'Сообщение': 'Message',
  'Расскажите, что произошло': 'Tell us what happened',
  'Отправить обращение': 'Submit request',
  'Отправляем…': 'Sending…',
  'К обращениям': 'Back to requests',
  'Открыть снова': 'Reopen',
  'Закрыть обращение': 'Close request',
  'Напишите сообщение поддержке': 'Write a message to support',
  'Загружаем обращения…': 'Loading requests…',
  'Обращений пока нет. Создайте первое, если понадобится помощь.': 'No support requests yet. Create one if you need assistance.',
  'Изменён': 'Changed',
  'Используется в датах и уведомлениях': 'Used for dates and notifications',
  'Используется в датах контрольных точек и уведомлениях': 'Used for checkpoint dates and notifications',
  'К перевозке': 'Transport details',
  'Как и о чём мы вам сообщаем. Push — в браузере и приложении, SMS — только для критичных событий.': 'Choose how we contact you. Push works in the browser and app; SMS is reserved for critical events.',
  'Как выбрать перевозчика?': 'How do I choose a carrier?',
  'Сравните профиль, верификацию, портфолио и отзывы. Условия можно обсудить в приватном чате.': 'Compare profiles, verification, portfolios and reviews. You can discuss the terms in a private chat.',
  'Что делать, если возникла проблема в поездке?': 'What should I do if there is a problem during the trip?',
  'Создайте обращение с темой «Спор» и опишите ситуацию.': 'Create a support request with the topic “Dispute” and describe the situation.',
  'Где посмотреть статус перевозки?': 'Where can I see the transport status?',
  'Статус и контрольные точки доступны в разделе «Активные перевозки».': 'The status and checkpoints are available under Active transports.',
  'Не удалось загрузить обращения.': 'Could not load support requests.',
  'Качество отчётов с фото': 'Photo report quality',
  'Когда перевозчик отправил предложение': 'When a carrier sends an offer',
  'Комментарий': 'Comment',
  'Компенсация ущерба': 'Damage compensation',
  'Конвертация по курсу ЦБ': 'Converted at the central bank rate',
  'Контакт при доставке': 'Delivery contact',
  'Контакт при заборе': 'Pickup contact',
  'Контактные данные': 'Contact details',
  'Контрольные точки': 'Checkpoints',
  'Контрольные точки перевозки': 'Transport checkpoints',
  'Корм с собой': 'Food provided',
  'Кормит перевозчик': 'Carrier provides food',
  'Кормление': 'Feeding',
  'месяц': 'month',
  'месяца': 'months',
  'месяцев': 'months',
  'Мой профиль': 'My profile',
  'Назад к чату': 'Back to chat',
  'Написать в чат': 'Open chat',
  'Напишите сообщение…': 'Write a message…',
  'Например: «Получили собаку в крайне нервном состоянии...».\nЧем подробнее — тем быстрее разберётся модератор.': 'For example: “The dog arrived extremely distressed…”\nMore detail helps the moderator resolve the issue faster.',
  'Например: добавить GPS-трекинг, увеличить количество перевозчиков в моём регионе, упростить выбор...': 'For example: add GPS tracking, bring more carriers to my region, simplify selection…',
  'Нарушены условия': 'Terms were breached',
  'Насколько удобно вам было пользоваться LOVO?': 'How easy was LOVO to use?',
  'Не выбран': 'Not selected',
  'Не выбрано': 'Not selected',
  'Не доставлен': 'Not delivered',
  'Не загружались фото с этапов перевозки': 'No photos were uploaded from the transport stages',
  'Не поддерживаются': 'Not supported',
  'не подтверждён': 'not confirmed',
  'Не соблюдались договорённости (корм, переноска, отчёты)': 'Agreed requirements were not followed (food, carrier, reports)',
  'Не согласована': 'Not agreed',
  'Не удалось загрузить вложение.': 'Could not upload the attachment.',
  'Новое сообщение от перевозчика': 'New message from a carrier',
  'Новое фото или обновление статуса от перевозчика': 'New photo or status update from a carrier',
  'Новое фото или статус': 'New photo or status',
  'Новости и рекомендации LOVO': 'LOVO news and recommendations',
  'Новости LOVO': 'LOVO news',
  'Новые отклики': 'New offers',
  'Новые отклики на мою заявку': 'New offers for my request',
  'Нужна переноска перевозчика': 'Carrier must provide a pet carrier',
  'Общая оценка': 'Overall rating',
  'Ожидается': 'Expected',
  'Ожидаем подтверждения перевозчика': 'Awaiting carrier confirmation',
  'Онлайн': 'Online',
  'Опишите свободно': 'Describe the issue',
  'оплат вовремя': 'payments on time',
  'Оплата выполняется напрямую перевозчику. Условия и способ оплаты зафиксируются в сделке.': 'Payment is made directly to the carrier. The terms and payment method are recorded in the deal.',
  'Оплата напрямую перевозчику — реквизиты согласуйте в чате. LOVO в платежах не участвует.': 'Pay the carrier directly and agree the details in chat. LOVO does not process the payment.',
  'Оплата подтверждена': 'Payment confirmed',
  'Опубликовать отзыв': 'Publish review',
  'Особенности': 'Special requirements',
  'Оставить отзыв': 'Leave a review',
  'Оставьте отзыв': 'Leave a review',
  'Ответить перевозчику': 'Reply to carrier',
  'Ответить публично': 'Reply publicly',
  'Отзыв опубликован': 'Review published',
  'Отзыв перевозчика о вас': 'Carrier review about you',
  'Отзывы перевозчиков': 'Carrier reviews',
  'Отзывы пока что отсутствуют': 'No carrier reviews yet',
  'Отклики перевозчиков': 'Carrier offers',
  'Откликов пока нет': 'No offers yet',
  'Отклонена': 'Declined',
  'Открыт': 'Open',
  'Открыть чат': 'Open chat',
  'Отправить': 'Send',
  'Отправлен': 'Sent',
  'Отправлено': 'Sent',
  'Отсутствие отчётов': 'Missing reports',
  'Параметры перевозки': 'Transport details',
  'Перевозка завершена': 'Transport completed',
  'Перевозчики спрашивают': 'Questions from carriers',
  'Перевозчики уточняют детали до отклика. Ответ увидят все перевозчики. Личные данные обсуждайте в приватном чате.': 'Carriers can ask for details before sending an offer. All carriers will see your answer. Discuss personal details in a private chat.',
  'Вы уже оставили отзыв о перевозчике.': 'You have already reviewed the carrier.',
  'Теперь вы можете оставить отзыв о перевозчике и оценить качество поездки.': 'You can now review the carrier and rate the transport.',
  'У вас готовы документы для Германии?': 'Are your documents for Germany ready?',
  'Перевозка завершена?': 'Is the transport complete?',
  'Перевозка запланирована': 'Transport scheduled',
  'Перевозчик выбран': 'Carrier selected',
  'Перевозчик задал вопрос': 'Carrier asked a question',
  'Перевозчик задал вопрос, чтобы уточнить': 'Carrier asked a question for clarification',
  'Перевозчик пропал, перевозка не выполнена': 'The carrier disappeared and the transport was not completed',
  'Перевозчик уже оставил отзыв о вас.': 'The carrier has already reviewed you.',
  'Переподключение…': 'Reconnecting…',
  'Питомец получен с признаками стресса, травмы или плохого ухода': 'The pet arrived showing signs of stress, injury or poor care',
  'Подать спор': 'Open dispute',
  'подтверждён': 'confirmed',
  'Подтверждён': 'Confirmed',
  'Подтверждение перевозчика': 'Carrier confirmation',
  'подтверждённых заявок': 'confirmed requests',
  'Поиск по чатам': 'Search chats',
  'Полный возврат': 'Full refund',
  'Поможете нам стать лучше?': 'Help us improve?',
  'После доставки вы сможете оставить отзыв о перевозчике.': 'You can review the carrier after delivery.',
  'После подачи модератор LOVO свяжется с обеими сторонами в течение 24 часов. Чат с перевозчиком останется открыт.': 'After submission, a LOVO moderator will contact both parties within 24 hours. The carrier chat will remain open.',
  'После подтверждения будет создана сделка, откроется чат и начнётся подготовка к перевозке.': 'Confirmation creates the deal, opens the chat and starts transport preparation.',
  'Последнее изменение:': 'Last changed:',
  'Предыдущие сообщения': 'Previous messages',
  'Приватные чаты с перевозчиками по вашим заявкам': 'Private chats with carriers about your requests',
  'Привязанные аккаунты': 'Linked accounts',
  'Прикрепить файл': 'Attach file',
  'Приложите доказательства': 'Attach evidence',
  'Принята': 'Accepted',
  'Причина спора': 'Dispute reason',
  'Проверьте условия отклика перед созданием сделки': 'Review the offer terms before creating the deal',
  'Прочитано': 'Read',
  'Прочитать все': 'Mark all as read',
  'Публичные вопросы к заявке': 'Public questions about the request',
  'Раз в неделю — обновления сервиса': 'Weekly product updates',
  'Раз в неделю — обновления сервиса, советы, промо-направления': 'Weekly product updates, advice and featured routes',
  'Разделы настроек': 'Settings sections',
  'Разрешены': 'Enabled',
  'Расчёты по сделке': 'Deal payments',
  'Рейтинг как заказчика': 'Customer rating',
  'Решён': 'Resolved',
  'Решения модератора по вашему спору': 'Moderator decisions for your dispute',
  'Решения модератора по спору': 'Moderator dispute decisions',
  'Связь и общение': 'Communication',
  'сегодня': 'today',
  'сейчас': 'now',
  'Сейчас у вас нет активных перевозок. Выберите отклик перевозчика в ваших заявках, чтобы начать перевозку.': 'You have no active transports. Accept a carrier offer in one of your requests to start a transport.',
  'Сельскохозяйственное животное': 'Farm animal',
  'Серьёзная задержка': 'Major delay',
  'Сменить пароль': 'Change password',
  'Соблюдение сроков': 'On-time performance',
  'Согласована напрямую': 'Agreed directly',
  'Согласовать оплату': 'Agree payment',
  'Сообщения в чате': 'Chat messages',
  'Сообщить о проблеме': 'Report a problem',
  'Состояние питомца': 'Pet condition',
  'Спасибо за отзыв! Теперь пара секунд про сам сервис — что понравилось, что бесит. Мы реально читаем каждый ответ и используем для улучшений.': 'Thank you for the review! Now tell us briefly what worked and what did not. We read every response and use it to improve LOVO.',
  'Спор': 'Dispute',
  'Спорные ситуации': 'Disputes',
  'Спорные ситуации нельзя отключить.': 'Dispute notifications cannot be disabled.',
  'Спорные ситуации приходят по всем каналам всегда — нельзя отключить.': 'Dispute notifications are always sent through every channel and cannot be disabled.',
  'Срыв сроков более чем на сутки без согласования': 'A delay of more than 24 hours without agreement',
  'Стоимость перевозки': 'Transport price',
  'Также для писем и SMS': 'Also used for email and SMS',
  'Также применяется к письмам и SMS': 'Also applies to email and SMS',
  'Текущий пароль': 'Current password',
  'Текущий этап': 'Current stage',
  'Только разобраться': 'Review the situation only',
  'Уведомления заблокированы в браузере. Чтобы включить их, нажмите на иконку настроек сайта слева в адресной строке браузера и разрешите уведомления.': 'Browser notifications are blocked. Open the site settings beside the address bar and allow notifications.',
  'Уведомления успешно подключены!': 'Notifications enabled successfully!',
  'Уведомления, пароль и язык': 'Notifications, password and language',
  'Уведомления, пароль и язык интерфейса': 'Notifications, password and interface language',
  'Фото с этой перевозки': 'Photos from this transport',
  'Фото с этой перевозки (автоматически)': 'Photos from this transport (automatic)',
  'Ход перевозки': 'Transport progress',
  'Цена — в чате': 'Price discussed in chat',
  'Цены в заявках заказчиков конвертируются по курсу ЦБ': 'Customer request prices are converted using the central bank rate',
  'Цены специально скрыты. Выбирайте по портфолио, рейтингу и отзывам, а стоимость обсудите в приватном чате.': 'Prices are hidden. Compare portfolios, ratings and reviews, then discuss the price in a private chat.',
  'Часовой пояс': 'Time zone',
  'Частичный возврат': 'Partial refund',
  'Черновик': 'Draft',
  'Что можно улучшить?': 'What could be improved?',
  'Что особенно понравилось?': 'What did you like most?',
  'Что понравилось...': 'What did you like…',
  'Что произошло?': 'What happened?',
  'Что хотите получить': 'Preferred resolution',
  'Что-то пошло не так?': 'Did something go wrong?',
  'Что-то не так': 'Something is wrong',
  'Email-рассылка': 'Email newsletter',
  'Посмотреть, как видит перевозчик →': 'Preview as carrier →',
  '← Вернуться во внутренний вид': '← Return to private view',
  'Push — в браузере и приложении, SMS — только для критичных событий.': 'Push works in the browser and app; SMS is reserved for critical events.',
  'Push в браузере': 'Browser push',
  'Push-уведомления в браузере:': 'Browser push notifications:',
  'Push, Email, SMS — выберите каналы для каждого события.': 'Choose Push, Email or SMS for each event.',
  'SMS об активной перевозке': 'SMS about active transport',
  'Я оплатил': 'I have paid',
  'Ждёт ответа': 'Awaiting answer',
  'Отправить отзыв о платформе': 'Submit platform feedback',
  'Проверить разрешения': 'Check permissions',
  'Подтвердить выбор': 'Confirm selection',
  'Повторить': 'Retry',
};
